export default defineNuxtPlugin(async () => {
	const { Notyf } = await import('notyf')
	await import('notyf/notyf.min.css')

	const notyf = new Notyf({
		position: { x: 'center', y: 'top' },
		duration: 3000,
	})

	return {
		provide: { notyf },
	}
})
